import React from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TableSortLabel,
  Menu,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { SlOptionsVertical } from "react-icons/sl";
import { Box, Checkbox, Grid, MenuItem, Typography } from "@mui/material";
import { AiOutlineEye } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { TbEdit } from "react-icons/tb";
import TableNoItemComponent from "../../../customComponent/TableNoItemComponent";

function WithdrawalHistoryTable({ data }) {
  const columns = [
    {
      title: "SL NO",
      field: "sl",
    },
    {
      title: "Date",
      field: "date",
    },
    {
      title: "Amount",
      field: "amount",
    },
    {
      title: "bank name",
      field: "bankName",
    },
    {
      title: "account holder name",
      field: "accountHolderName",
    },
    {
      title: "account number",
      field: "accountNumber",
    },
    {
      title: "ifsc number",
      field: "ifscNumber",
    },
  ];

  // const data = [
  //   {
  //     date: "15 / 05 / 2023",
  //     amount: "977584421",
  //     bank: "shabeer. muhammed@gmail.com",
  //     name: "Shabeer Muhammed",
  //     accountHolderName: "Scotland",
  //     ifscNumber: "Enrolled",
  //   },
  //   {
  //     date: "15 / 05 / 2023",
  //     amount: "977584421",
  //     bank: "shabeer. muhammed@gmail.com",
  //     name: "Shabeer Muhammed",
  //     accountHolderName: "Scotland",
  //     ifscNumber: "Enrolled",
  //   },
  //   {
  //     date: "15 / 05 / 2023",
  //     amount: "977584421",
  //     bank: "shabeer. muhammed@gmail.com",
  //     name: "Shabeer Muhammed",
  //     accountHolderName: "Scotland",
  //     ifscNumber: "Enrolled",
  //   },
  //   {
  //     date: "15 / 05 / 2023",
  //     amount: "977584421",
  //     bank: "shabeer. muhammed@gmail.com",
  //     name: "Shabeer Muhammed",
  //     accountHolderName: "Scotland",
  //     ifscNumber: "Enrolled",
  //   },
  //   {
  //     date: "15 / 05 / 2023",
  //     amount: "977584421",
  //     bank: "shabeer. muhammed@gmail.com",
  //     name: "Shabeer Muhammed",
  //     accountHolderName: "Scotland",
  //     ifscNumber: "Enrolled",
  //   },
  // ];

  const convertToDate = (date) => {
    let timestamp = new Date(date);
    return timestamp.toLocaleDateString();
  };

  return data?.length === 0 ? (
    <TableNoItemComponent />
  ) : (
    <div
      style={{
        overflowX: "scroll",
        border: "0px solid #ffff",
      }}
      className="scrollBar"
    >
      <Table className="EmployeeJobTable">
        <TableHead>
          <TableRow className="EmployeeJobTableCell">
            {/* <TableCell
              style={{
                position: "sticky",
                left: 0,
                zIndex: 1,
                padding: "1px",
                border: "1px solid #ddd",
                backgroundColor: "#fafafa",
              }}
            >
              <Checkbox
                //   checked={selectedRows?.length === sortedData?.length}
                //   onChange={handleSelectAllRows}
                style={{ color: "#f81b82" }}
              />
            </TableCell> */}
            {columns?.map((column) => {
              return (
                <TableCell
                  key={column.field}
                  className="EmployeeJobTableCell LeadCommon"
                  style={{ padding: "10px 16px", whiteSpace: "nowrap" }}
                >
                  <TableSortLabel
                    className="LeadHeaderText"
                    //   active={column === sortBy}
                    //   direction={sortOrder}
                    //   onClick={() => requestSort(column)}
                    //   IconComponent={column.field !== "action" && CustomSortIcon}
                    sx={{
                      textTransform: "uppercase",
                      fontWeight: "700",
                      color: "#666E7D",
                    }}
                  >
                    {column.title}
                  </TableSortLabel>
                </TableCell>
              );
            })}
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.map((item, indx) => (
            <TableRow className="EmployeeJobTable" key={indx}>
              {/* <TableCell
                style={{
                  position: "sticky",
                  left: 0,
                  zIndex: 1, // To ensure it's above other cells
                  backgroundColor: "white", // Adjust as needed
                  padding: "1px",
                  border: "1px solid #ddd",
                }}
              >
                <Checkbox
                  // checked={selectedRows.includes(item.id)}
                  // onChange={() => handleSelectRow(item.id)}
                  style={{ color: "#f81b82" }}
                />
              </TableCell> */}
              <TableCell style={{ padding: "10px 16px", whiteSpace: "nowrap" }}>
                {indx + 1}
              </TableCell>
              <TableCell style={{ padding: "10px 16px", whiteSpace: "nowrap" }}>
                {convertToDate(item.updatedAt)}
              </TableCell>

              <TableCell style={{ padding: "10px 16px", whiteSpace: "nowrap" }}>
                {item.amount}
              </TableCell>

              <TableCell style={{ padding: "10px 16px", whiteSpace: "nowrap" }}>
                {item.BankName}
              </TableCell>

              <TableCell style={{ padding: "10px 16px", whiteSpace: "nowrap" }}>
                {item.accountHolderName}
              </TableCell>

              <TableCell style={{ padding: "10px 16px", whiteSpace: "nowrap" }}>
                {item.AccountNumber}
              </TableCell>

              <TableCell style={{ padding: "10px 16px", whiteSpace: "nowrap" }}>
                {item.ifsc}
              </TableCell>

              {/* <TableCell
                style={{
                  padding: "0 16px",
                  whiteSpace: "nowrap",
                  width: "20px",
                }}
              >
                <SlOptionsVertical
                  id="demo-positioned-button"
                  // aria-controls={
                  //   leadOpenActionButton ? "demo-positioned-menu" : undefined
                  // }
                  aria-haspopup="true"
                  // aria-expanded={leadOpenActionButton ? "true" : undefined}
                  // onClick={(e) => {
                  //   handleClickAction(e, item.id);
                  // }}
                  variant="outlined"
                  style={{ marginLeft: "10px", color: "#F80B7A" }}
                  sx={{
                    backgroundColor: "#141E3C",
                    size: "10px",
                    padding: 1,
                    margin: 3,
                    color: "#fff",
                    width: "75px",
                    height: "40px",
                    cursor: "pointer",
                  }}
                />
                <Menu
                  id="demo-positioned-menu"
                  aria-labelledby="demo-positioned-button"
                  // open={leadActionButtonShow}
                  // onClose={handleCloseAction}
                  // anchorEl={leadActionButtonShow}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                  anchorOrigin={{
                    vertical: "bottom", // Change from "top" to "bottom"
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top", // Change from "top" to "bottom"
                    horizontal: "left",
                  }}
                  sx={{
                    borderColor: "black",
                    borderRadius: "24px",
                    mt: 1.5,
                    width: "auto",
                    height: "auto",
                  }}
                >
                  <Box
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <MenuItem>
                      <AiOutlineEye
                        style={{
                          fontSize: "lg",
                          width: "20px",
                          height: "19px",
                        }}
                        //   onClick={() =>
                        //     navigate(`/ielts/teacherManagment/view/${tableId}`)
                        //   }
                      />
                    </MenuItem>
                    <MenuItem>
                      <TbEdit
                        style={{
                          fontSize: "lg",
                          width: "20px",
                          height: "19px",
                        }}
                        //   onClick={() =>
                        //     navigate(
                        //       `/ielts/teacherManagment/editTeacher/${tableId}`
                        //     )
                        //   }
                        className="icons"
                      />
                    </MenuItem>
                  </Box>
                </Menu>{" "}
              </TableCell> */}
            </TableRow>
          ))}
        </TableBody>
        <TableFooter />
      </Table>
    </div>
  );
}

export default WithdrawalHistoryTable;
